export function Fields(client) {
    return {
        search(masterAccountId, searchString, fieldType, entities) {
            const params = { column_header: searchString };
            if (fieldType) {
                params['field_type'] = fieldType;
            }
            if (entities) {
                params['entities'] = entities.join();
            }
            return client.get(`/accounts/${masterAccountId}/fields/search`, { params });
        },
        get(masterAccountId, entities, requiredOnly) {
            const params = {};
            if (entities) {
                params['entities'] = entities.join();
            }
            if (requiredOnly) {
                params['required_only'] = requiredOnly;
            }
            return client.get(`/accounts/${masterAccountId}/fields`, { params });
        }
    };
}
